import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Menu, Button, Popover } from 'antd';
import { UserOutlined, WhatsAppOutlined, InstagramOutlined, FacebookOutlined, LogoutOutlined, GlobalOutlined } from '@ant-design/icons';
import apiConnect from '../../../config/apiConfig';
import style from './navegation.module.scss';

const Navegation = ()=> {
  const history = useHistory();
  const [user, setUser] = useState([]);

  const userId = localStorage.getItem('id');
  const token = localStorage.getItem('jwt');

  const { Item } = Menu;

  const {
    container,
    brand,
    items,
    itemLink,
    icon,
    nav,
    divSession,
    socialMedia,
    iconSocial,
    divLogout,
    btn
  } = style;

  useEffect(() => {
    const getUser = async () => {
      try {
        const { data } = await apiConnect.get(`/users/${userId}`);
        setUser(data.data[0]);
      } catch(error) {
        console.log(error);
      }
    };

    getUser();
  }, []);


  const logout = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    history.push('/');
  };

  const imgLogo = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/rounded_logo_expo.png`;
  return (
    <div className={container}>
      <img
        src={imgLogo}
        alt="logo drogueria suiza"
        className={brand}
      />
      <div className={items}>
        <div className={nav}>
          <Menu
            mode="horizontal"
          >
            <Item key='1'>
              <Link
                to={'/provider'}
                className={itemLink}
              >
                Stands
              </Link>
            </Item>
            <Item key='3'>
              <Link
                to={'/provider/mis-ventas'}
                className={itemLink}
              >
                Ventas
              </Link>
            </Item>
            <Item key='4'>
              <Link
                to={'/provider/mis-combos'}
                className={itemLink}
              >
                Combos
              </Link>
            </Item>
            <Item key=''>
              <Link
                to={`/provider/sell/${userId}`}
                className={itemLink}
              >
                Pedido
              </Link>
            </Item>
            <Item key='2'>
              <Link
                to={'/signPage/entry'}
                className={itemLink}
              >
                Ver expo
              </Link>
            </Item>
          </Menu>
        </div>
        <div className={divSession}>
          {
            token 
            &&
            <>
              <div className={socialMedia}>
                <Popover
                  content='Sitio web'
                >
                  <a
                    href='http://www.dsuiza.com.ar/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <GlobalOutlined className={iconSocial}/>
                  </a>
                </Popover>
                <Popover
                  content='Whatsapp'
                >
                  <a
                    href='https://api.whatsapp.com/send/?phone=%2b5493816202489&text&app_absent=0'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <WhatsAppOutlined className={iconSocial}/>
                  </a>
                </Popover>
                <Popover
                  content='Facebook'
                >
                  <a
                    href='https://www.facebook.com/Droguer%C3%ADa-Suiza-103860248656657'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <FacebookOutlined className={iconSocial}/>
                  </a>
                </Popover>
                <Popover
                  content='Instagram'
                >
                  <a
                    href='https://www.instagram.com/drogueriasuiza.ok'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <InstagramOutlined className={iconSocial}/>
                  </a>
                </Popover>
              </div>
              <div className={divLogout}>
                <div>
                  <UserOutlined className={icon}/>
                  <h4>
                    {user && (user.fullName || user.accountNumber || user.email)}
                  </h4>
                </div>
                <div>
                  <Button
                    icon={<LogoutOutlined className={icon}/>}
                    className={btn}
                    onClick={() => logout()}
                  >
                    Cerrar sesión
                  </Button>
                </div>
              </div>
            </>
          }
        </div>
      </div>
    </div>
  );
};

export default Navegation;